import React from "react";
import { Input } from "antd";
import { SplitInputWrapperProps, InputWrapper } from "../../functions";
import { PasswordInputBoxProps } from "./interface";
import EyesOpen from "../../../../assets/images/icon/eye-open.svg?react";
import EyesClosed from "../../../../assets/images/icon/eye-closed.svg?react";
const PasswordInputBox: React.FC<PasswordInputBoxProps> = (props) => {
	const { formProps, inputProps } = SplitInputWrapperProps(props);
	return (
		<InputWrapper {...formProps}>
			<Input.Password {...inputProps} iconRender={(visible) => (visible ? <EyesOpen/> : <EyesClosed/>)} />
		</InputWrapper>
	);
};

export default PasswordInputBox;
